import { Product, ProductTriggerType } from '@schooly/api';
import { SchoolUserRole } from '@schooly/constants';
import { useSchoolProperties } from '@schooly/hooks/use-school-properties';
import { ModalContent, ModalLarge } from '@schooly/style';
import { FC } from 'react';

import { SchoolProductModalHeader } from '../SchoolProductModalHeader';
import { OnEditVariantsParams } from './SchoolProductModal';
import { SchoolProductModalVariants } from './SchoolProductModalVariants';

type SchoolProductModalContentProps = {
  product: Product;
  schoolId: string;
  onEdit?: () => void;
  onEditVariants?: (params: OnEditVariantsParams) => void;
  onClose: () => void;
};

export const SchoolProductModalContent: FC<SchoolProductModalContentProps> = ({
  product,
  schoolId,
  onClose,
  onEditVariants,
}) => {
  const { name, obligatory, triggers, type } = product;
  const { propertiesMap } = useSchoolProperties({ schoolId, userType: SchoolUserRole.Student });

  const registrationTrigger = triggers.find(
    (t) => t.trigger_type === ProductTriggerType.RegistrationUpdate,
  );
  const statusName = registrationTrigger?.extra_data?.status
    ? propertiesMap.status.find((s) => s.id === registrationTrigger?.extra_data?.status)?.name
    : undefined;

  return (
    <ModalLarge open onClose={onClose}>
      <SchoolProductModalHeader
        name={name}
        obligatory={obligatory}
        statusName={statusName}
        onClose={onClose}
        triggerTextId={
          registrationTrigger ? 'products-Trigger-Status' : 'products-Trigger-SingleInvoice'
        }
        type={type}
      />
      <ModalContent display="flex" flexDirection="column">
        <SchoolProductModalVariants product={product} schoolId={schoolId} onEdit={onEditVariants} />
      </ModalContent>
    </ModalLarge>
  );
};
